import styled from '@emotion/styled'
import React from 'react'
import { AgendarStore } from '../AgendarStore'
import { format, parseISO, formatDistanceToNow, set } from 'date-fns'
import { Button } from 'antd'
import { ReactComponent as FinishCobranca } from '../../../../assets/icons/finish.svg'
import { HyperpayCobranca } from '@hyperdev-tech/hyperpay-cobranca'
import { Show } from '../../../../components/common/Show'
import { ReactComponent as CopyIcon } from '../../../../assets/icons/copy2.svg'
import { getCobrancaUrl } from '../../../../components/common/getCobrancaUrl'

const DetalhesBoleto = () => {
  const { Layout, ContainerInfo, Linha, ButtonContainer, HyperpayCobranca, ContainerInfoCobranca } =
    DetalhesBoleto

  const { agendamento } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()

  function handleCobrancaSuccess() {
    dispatch(AgendarStore.thunks.handleCobranca(agendamento.cpf))
  }

  const cobrancaEnv = process.env.REACT_APP_ENV
    ? process.env.REACT_APP_ENV
    : (process.env.NODE_ENV as any)

  return (
    <>
      <Layout>
        <ContainerInfoCobranca>
          <FinishCobranca className="finish-cobranca-svg" />
          <TextsInfoCobranca />
        </ContainerInfoCobranca>
        <Show condition={!agendamento.readOnly}>
          <ContainerInfo>
            <ButtonContainer>
              <HyperpayCobranca
                cobrancaId={
                  agendamento?.identificadorCobranca ? +agendamento?.identificadorCobranca : 0
                }
                token="121b4545-2ef2-4016-903e-06289a7abb1b"
                env={cobrancaEnv}
                onCobrancaSuccess={() => handleCobrancaSuccess()}
                defaultOpened="PIX"
              />
            </ButtonContainer>
          </ContainerInfo>
        </Show>
      </Layout>
    </>
  )
}
DetalhesBoleto.Layout = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  @media (max-width: 900px) {
    flex-direction: column-reverse;
    gap: 5px;
  }
`
DetalhesBoleto.HyperpayCobranca = styled(HyperpayCobranca)`
  --primary-color: #fbba3e !important;
  --heading-container-color: transparent !important;
  .heading-container {
    margin-top: 0;
  }
`
DetalhesBoleto.ContainerInfo = styled.div`
  display: block;

  h1 {
    color: #fbba3e;
    font-size: 30px;
    font-weight: 700;
    margin: 0;
  }

  h2 {
    color: #545451;
    font-size: 20px;
    font-weight: 700;
    margin: 0;
  }

  p {
    color: #545451;
    font-size: 16px;
    margin: 0;
  }
`

DetalhesBoleto.Linha = styled.hr`
  border-top: 1px solid #ccc;
`

DetalhesBoleto.ButtonContainer = styled.div`
  display: flex;
  gap: 6px;
`
DetalhesBoleto.Imprimir = styled(Button)`
  display: flex;
  width: 170px;
  height: 35px;
  border-radius: 8px;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border: 0;
  place-content: center;

  background: #f7d047;
  color: #292926;

  &:hover {
    cursor: pointer;
    transition: 0.19s;
    background: #292926;
    color: #f7d047;
  }
`

DetalhesBoleto.ContainerInfoCobranca = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  .finish-cobranca-svg {
    height: 77px;
    width: 167px;
  }
  @media (max-width: 900px) {
    align-items: center;
  }
`
const TextsInfoCobranca = () => {
  const { Layout, NovoAgendamento, LinkPagamento } = TextsInfoCobranca
  const { agendamento, paramsPilotar } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()
  const [copied, setCopied] = React.useState(false)

  function handleClickNovoAgendamento() {
    dispatch(AgendarStore.actions.clear())
    location.reload()
  }

  const handleCopyPaymentLink = () => {
    if (!agendamento?.identificadorCobranca) return
    setCopied(true)
    const cobrancaUrl = getCobrancaUrl(+agendamento.identificadorCobranca)
    navigator.clipboard.writeText(cobrancaUrl)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <Layout>
      <span className="cobranca-gerada">Cobrança gerada com sucesso</span>
      <span className="aguardar-pagamento">Aguardando pagamento para liberar agendamento</span>
      <span className="text-cobranca">
        Cobrança: <strong>{agendamento?.identificadorCobranca}</strong>
      </span>
      <span className="text-datavencimento">
        Data de vencimento:{' '}
        <strong>
          {agendamento?.dataVencimento ? formatDate(agendamento.dataVencimento as any) : ''}
        </strong>
      </span>
      <Show condition={!paramsPilotar}>
        <NovoAgendamento onClick={handleClickNovoAgendamento}>Novo Agendamento + </NovoAgendamento>
      </Show>
      <Show condition={!!paramsPilotar && !agendamento.readOnly}>
        <LinkPagamento onClick={handleCopyPaymentLink} disabled={!!agendamento.readOnly}>
          <Show condition={!copied}>
            <span>Copiar link de pagamento</span>
          </Show>
          <Show condition={copied}>
            <span>Link Copiado!</span>
          </Show>
          <CopyIcon />
        </LinkPagamento>
      </Show>
    </Layout>
  )
}
TextsInfoCobranca.Layout = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  @media (max-width: 900px) {
    align-items: center;
  }
  .cobranca-gerada {
    color: #3a3a3a;
    font-size: 25px;
    font-weight: 600;
  }
  .aguardar-pagamento {
    font-size: 15px;
    color: #343a40;
    margin-bottom: 10px;
  }
  .text-cobranca,
  .text-datavencimento {
    color: #343a40;
  }
  strong {
    color: #3a3a3a;
  }
`
TextsInfoCobranca.NovoAgendamento = styled(Button)`
  display: flex;
  width: 170px;
  height: 35px;
  border-radius: 8px;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #7f7f7d;
  place-content: center;
  align-self: center;

  &:hover {
    cursor: pointer;
    transition: 0.19s;
    background: #292926;
    border: 1px solid #292926;
    color: #fff;
  }
`
TextsInfoCobranca.LinkPagamento = styled(Button)`
  background: #fbba3e !important;
  border: none !important;
  box-shadow: none !important;
  text-shadow: none !important;
  margin-top: 10px;
  border-radius: 8px;
  padding: 7px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 240px;
  gap: 7px;
  @media (max-width: 900px) {
    width: 100%;
  }
  span {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
  &:hover,
  &:focus,
  &:active {
    background: #fbba3e;
    border: none;
    filter: brightness(0.9);
  }
  &:disabled {
    background: #c2c2c2 !important;
    border: 1px solid #c2c2c2 !important;
    cursor: not-allowed;
  }
`

const formatDate = (data: string) => {
  return format(parseISO(data), 'dd/MM/yyyy')
}

export default DetalhesBoleto
